import { STATES } from '../../../../constants';

export const STATE_NAME = STATES.STEP_MOVING_CENTER_FORM;
const PAGE_TITLE = 'Book Your Move';

export function MovingCenterFormConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATE_NAME, {
    url: '',
    views: {
      '@': {
        template: `<upd-moving-center-form></upd-moving-center-form>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    titleBar: {
      title: PAGE_TITLE,
      icon: 'movingtruck',
    },
    analytics: {
      page: 'MC Form',
    },
    data: {
      permissions: 'signedIn && !hasMovingCenterData',
    },
  });
}
